export function verifyAdmin(admin, position) {
  if(!admin) return null;
  
  const verify = admin.role.filter(fiItem => fiItem === position).length;
  return verify === 1 ? true : false;
}

export function verifyDeveloper(admin) {
  if (!admin || !admin.role || !Array.isArray(admin.role)) return false;
  return admin.role.includes('developer');
}